import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';
import {AppState} from '../../../../core/reducers';
import {currentUser} from '../../../../core/auth';
import {AuthService, MobileAppService} from '../../../../core/services';
import { LogoutAction, LogoutSuumoAction, ReloadCurrentUserAction } from '../../../../core/actions/auth.actions';
import { isSuumo, UserModel, USER_STATUS_ENABLE } from '../../../../core/models/user.model';

@Component({
    selector: 'kt-change-password',
    templateUrl: './change-password.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
    form: FormGroup;

    loading = false;

    errors: any[] = [];

    notices = [];

    private unsubscribe: Subject<null>;

    currentUser: UserModel | undefined;
    private token: string | undefined;

    loginType: "order-go" | "suumo" = "order-go";
    sent = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private mobileAppService: MobileAppService,
        private cdr: ChangeDetectorRef,
        private store: Store<AppState>) {
        this.unsubscribe = new Subject();
    }

    ngOnInit(): void {
        this.initForm();

        this.form.valueChanges.subscribe((value) => {
            if (this.form.controls["newPassword"].hasError("wrongPassword")) {
                this.form.controls["newPassword"].setErrors(null);
            }
        });
        this.store.pipe(select(currentUser), takeUntil(this.unsubscribe)).subscribe((user) => {
            this.currentUser = user;
            if (this.currentUser !== undefined && isSuumo(this.currentUser)) {
                this.loginType === "suumo";
            }
        });
        this.activatedRoute.params.subscribe((param) => {
            const token: string | undefined = param.token;
            if (!token) {
                return;
            }
            this.token = token;
        });
        this.activatedRoute.queryParams.subscribe((params) => {
            console.warn(params);
            if (params?.loginType === "suumo") {
                this.loginType = "suumo";
                this.cdr.detectChanges();
            }
        })
    }

    ngOnDestroy(): void {
        this.unsubscribe.next(null);
        this.unsubscribe.complete();
        this.loading = false;
    }

    initForm() {
        this.form = this.formBuilder.group({
            newPassword: ['', 
                Validators.compose([
                    Validators.required,
                    Validators.minLength(3),
                    Validators.maxLength(100)
                ])
            ],
            confirmPassword: ['', Validators.required]
        }, {
            validator: (formGroup: FormGroup) => {
                const newPassword = formGroup.controls.newPassword;
                const confirmPassword = formGroup.controls.confirmPassword;
                if (newPassword.value !== confirmPassword.value) {
                    confirmPassword.setErrors({ mustMatch: true });
                } else {
                    confirmPassword.setErrors(null);
                
                }
            }
        });
    }

    submit() {
        const controls = this.form.controls;
        if (this.form.invalid) {
            Object.keys(controls).forEach(controlName => {
                controls[controlName].markAsTouched();
            });
            this.cdr.detectChanges();
            return;
        }

        this.loading = true;
        if (this.currentUser !== undefined) {
            this.authService.changePassword(controls.newPassword.value, true).subscribe((_) => {
                this.store.dispatch(new ReloadCurrentUserAction({}));
                this.store.pipe(select(currentUser), takeUntil(this.unsubscribe)).subscribe(user => {
                    if (user && user.status === USER_STATUS_ENABLE) {
                        this.router.navigateByUrl("/dashboard");
                    }
                });
            });
        }
        if (this.token !== undefined) {
            this.authService.executeChangePasswordTrial(this.token, controls.newPassword.value).subscribe(({ok}) => {
                this.loading = false;
                if (ok) {
                    console.warn("ok");
                    this.sent = true;
                }
                this.cdr.detectChanges();
            })
        }
    }

    isControlHasError(controlName: "newPassword" | "confirmPassword", validationType: string): boolean {
        const control = this.form.controls[controlName];
        if (!control) {
            return false;
        }
        return control.errors && control.errors[validationType] && control.touched;
    }

    logout() {
        if (!this.currentUser) {
            return;
        }
        this.mobileAppService.logout(this.currentUser.id);
        if (isSuumo(this.currentUser)) {
            this.store.dispatch(new LogoutSuumoAction());
        } else {
            this.store.dispatch(new LogoutAction());
        }
    }

    isSuumo() {
        if (this.currentUser) {
            return isSuumo(this.currentUser);
        }
        return false;
    }
}

